"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(require("underscore"));

/**
 *  Copyright (c) 2016, The Regents of the University of California,
 *  through Lawrence Berkeley National Laboratory (subject to receipt
 *  of any required approvals from the U.S. Dept. of Energy).
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree.
 */

/**
 * Base class for objects in the processing chain which
 * need other object to listen to them. It provides a basic
 * interface to define the relationships and to emit events
 * to the interested observers.
 */
class Observable {
  constructor() {
    this._id = _underscore.default.uniqueId("id-");
    this._observers = [];
  }

  emit(event) {
    this._observers.forEach(observer => {
      observer.addEvent(event);
    });
  }

  flush() {
    this._observers.forEach(observer => {
      observer.flush();
    });
  }

  addObserver(observer) {
    var shouldAdd = true;

    this._observers.forEach(o => {
      if (o === observer) {
        shouldAdd = false;
      }
    });

    if (shouldAdd) this._observers.push(observer);
  }

  hasObservers() {
    return this._observers.length > 0;
  }

}

var _default = Observable;
exports.default = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/pondjs/lib/lib/base/observable.js
 ** module id = 670
 ** module chunks = 0
 **/